import { render } from "./UsdIcon.vue?vue&type=template&id=3133bdd5"
import script from "./UsdIcon.vue?vue&type=script&lang=js"
export * from "./UsdIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__